export default function Sparkline({ values = [], avg, className = '' }) {
  const safeValues = values.length > 0 ? values : [0, 0, 0, 0, 0, 0, 0];
  const max = Math.max(...safeValues, 1);

  const today = new Date();
  const labels = safeValues.map((_, i) => {
    const d = new Date(today);
    d.setDate(d.getDate() - (safeValues.length - 1 - i));
    return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  });

  const avgPct = avg != null ? Math.max((avg / max) * 100, 2) : null;

  return (
    <div className={`relative flex items-end gap-px ${className}`} role="img" aria-label={`Last ${safeValues.length} days trend`}>
      {avgPct != null && (
        <div
          className="absolute left-0 right-0 pointer-events-none z-10"
          style={{ bottom: `${avgPct}%`, borderTop: '1.5px dashed currentColor', opacity: 0.45 }}
          title={`7d avg: ${avg}`}
        />
      )}
      {safeValues.map((value, i) => (
        <div key={i} className="group relative flex-1" style={{ height: '100%', display: 'flex', alignItems: 'flex-end' }}>
          <div
            className="w-full rounded-sm bg-current opacity-60 group-hover:opacity-100 transition-opacity cursor-default"
            style={{ height: `${Math.max((value / max) * 100, 4)}%` }}
          />
          <div className="pointer-events-none absolute bottom-full left-1/2 -translate-x-1/2 mb-1 hidden group-hover:block z-50">
            <div className="whitespace-nowrap rounded bg-gray-900 px-2 py-1 text-[10px] font-medium text-white shadow-lg">
              {labels[i]}: {value}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
